const getNumbersTo = (to) => {
    const numbers = []
    for (let n = 1; n <= to; n += 1) {
        if (n < 10) {
            numbers.push(`0${n}`)
        } else {
            numbers.push(n)
        }
    }
    return numbers
}

const getYears = () => {
    const years = []
    const year = new Date().getFullYear()
    for (let y = year; y >= 1900; y -= 1) {
        years.push(y)
    }
    return years
}

export const years = getYears()

export const days = getNumbersTo(31)

export const months = getNumbersTo(12)
